import { useCallback, useMemo } from 'react';

import { CartPillOrgData } from 'components/CartPill/CartPillOrgData';
import { fetchUserEnvironment } from 'modules/main/store/ducks/userEnvironment.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

export function useUserEnvironmentCartPillOrgsData(): {
  orgsCartData: CartPillOrgData[] | undefined;
  reloadOrgsCartData: (orgId: string) => void;
} {
  const { user } = useUserEnvironment();

  const orgsCartData = useMemo(
    () =>
      user?.orgs?.map(
        (org) =>
          ({
            id: org.id,
            name: org.name,
            itemsCount: org.cartItemCount,
          }) satisfies CartPillOrgData,
      ),
    [user?.orgs],
  );

  const dispatch = useMainDispatch();
  const reloadOrgsCartData = useCallback(
    () => dispatch(fetchUserEnvironment()),
    [dispatch],
  );

  return { orgsCartData, reloadOrgsCartData };
}
